import { ImagesSubComponent } from '../images.sub.component';
import { openSheet } from '../../../_common/client/nexus-interfaces/product-room-fit-sheet';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';
import { cookie } from '@otto-ec/global-resources/cookie';

const PRODUCT_ROOM_FIT_GENERATION_WAS_USED_COOKIE = 'otto_prf';

export class ProductRoomFitBtnSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_product-room-fit-btn';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.createAndAppendButton();
        this.performViewTracking();
    }

    private createAndAppendButton() {
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }
        const buttonElement = document.createElement('oc-button-v1');
        buttonElement.classList.add('pdp_product-room-fit-btn__button');
        buttonElement.setAttribute('icon-type-left', 'sparkles');
        buttonElement.setAttribute('size', '50');
        buttonElement.setAttribute('variant', 'secondary');
        buttonElement.innerHTML = '<b>In meinen Raum generieren</b>';

        if (cookie.get(PRODUCT_ROOM_FIT_GENERATION_WAS_USED_COOKIE) !== 'feature_opened') {
            cookie.set(PRODUCT_ROOM_FIT_GENERATION_WAS_USED_COOKIE, 'feature_seen', { path: '/', days: 30 });
        }

        buttonElement.addEventListener('click', () => {
            cookie.set(PRODUCT_ROOM_FIT_GENERATION_WAS_USED_COOKIE, 'feature_opened', { path: '/', days: 30 });
            openSheet(variationId);
        });

        this.getRootElement().appendChild(buttonElement);
        this.getRootElement().classList.add('pdp_product-room-fit-btn');
    }

    private performViewTracking() {
        trackView({
            product_InteriorDesignConsultant: ['True'],
        });
    }

    protected onItemChanged() {}
}
